webpackJsonp([44],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = window.AMap;

/***/ }),

/***/ "1qkf":
/***/ (function(module, exports) {

var api = 'https://timebank.shenzhentimebank.cn/api/';

module.exports = {
  //管理员
  ADMIN: {
    findCarouselMapManage: api + 'app/system/findCarouselMapManage',
    findDemandActivityByPage: api + 'app/demand/activity/findDemandActivityByPage',
    getAboutInfo: api + 'app/system/getAboutInfo/',
    findFriendshipLinkByPage: api + 'app/system/findFriendshipLinkByPage',
    getConfigInfo: api + 'app/system/getConfigInfo',
    getContactInfo: api + 'app/system/getContactInfo',
    getUserAgreement: api + 'app/system/getUserAgreement',
    searchId: api + 'app/system/search/',
    findNewsByPage: api + 'app/system/findNewsByPage',
    findPublicWelfareByPage: api + 'app/system/findPublicWelfareByPage',
    findOne: api + 'app/demand/activity/findOne',
    findMsgBoardByPage: api + 'app/demand/activity/findMsgBoardByPage',
    findManagePage: api + 'app/system/findManagePage',
    userCore: api + 'app/user/core/', ///获取当前用户信息
    changeMobile: api + 'app/user/core/changeMobile', ///用户更改绑定手机
    checkMobile: api + 'app/user/core/checkMobile/', ///检查手机号是否被注册
    findUserInfo: api + 'app/user/core/findUserInfo/', ///获取用户信息
    login: api + 'app/user/core/login', ///用户名密码或短信登录
    logout: api + 'app/user/core/logout', ///登出
    register: api + 'app/user/core/register', ///用户注册
    resetPWD: api + 'app/user/core/resetPWD', ///重置密码/忘记密码
    saveUserInfo: api + 'app/user/core/saveUserInfo', ///保存用户基本信息
    saveServerUserInfo: api + 'app/user/core/server-info/save', ///保存用户服务信息
    points: api + 'app/user/points/', ///保存用户服务信息
    findUserUndertakeByPage: api + 'app/demand/activity/findUserUndertakeByPage', ///分页获取我的承接/活动
    findServerAddressByPage: api + 'app/server/findServerAddressByPage', ///分页获取用户服务地址列表/活动
    serverSave: api + 'app/server/save', ///分页获取用户服务地址列表/活动
    serverInfo: api + 'app/server/', ///分页获取用户服务地址列表/活动
    loadDictionary: api + 'base/sys/admin/loadDictionary', ///分页获取用户服务地址列表/活动
    findServerCommunity: api + 'app/system/serverCommunity/findServerCommunity', ///分页获取用户服务地址列表/活动
    flowPage: api + 'app/user/points/flow/page', ///分页获取用户服务地址列表/活动
    findMobileCode: api + 'base/verifyCode/findMobileCode', ///分页获取用户服务地址列表/活动
    findUserDemandActivityByPage: api + 'app/demand/activity/findUserDemandActivityByPage', ///分页获取用户服务地址列表/活动
    pointsdonate: api + 'app/user/points/donate', ///分页获取用户服务地址列表/活动
    findDemandGenre: api + 'app/demand/genre/findDemandGenre/y', ///分页获取用户服务地址列表/活动
    findDemandCategory: api + 'app/demand/genre/findDemandCategory', ///分页获取用户服务地址列表/活动
    findServerGroup: api + 'app/demand/genre/findServerGroup', ///分页获取用户服务地址列表/活动
    saveActivity: api + 'app/demand/activity/saveActivity', ///分页获取用户服务地址列表/活动
    findByActivity: api + 'app/demand/activity/apply/findByActivity', ///分页获取用户服务地址列表/活动
    serverDelete: api + 'app/server/delete/', ///分页获取用户服务地址列表/活动
    addMsgBoard: api + 'app/demand/activity/addMsgBoard', ///分页获取用户服务地址列表/活动
    activityApply: api + 'app/demand/activity/apply/activity/', ///分页获取用户服务地址列表/活动
    findUserInfoByid: api + 'app/user/core/findUserInfo/', ///分页获取用户服务地址列表/活动
    applyAudit: api + 'app/demand/activity/apply/audit/', ///分页获取用户服务地址列表/活动
    updateActivity: api + 'app/demand/activity/updateActivity', ///分页获取用户服务地址列表/活动
    activityCance: api + 'app/demand/activity/cancel/', ///分页获取用户服务地址列表/活动
    applyCancel: api + 'app/demand/activity/apply/cancel/', ///分页获取用户服务地址列表/活动
    activityCompelete: api + 'app/demand/activity/activity/complete/', ///分页获取用户服务地址列表/活动
    addEvaluation: api + 'app/user/evaluation/addEvaluation', ///分页获取用户服务地址列表/活动
    findAppUserEvaluationByPage: api + 'app/user/evaluation/findAppUserEvaluationByPage', ///分页获取用户服务地址列表/活动
    feedbackSave: api + 'app/system/feedback/save', ///分页获取用户服务地址列表/活动
    findFeedBackByPage: api + 'app/system/feedback/findFeedBackByPage', ///分页获取用户服务地址列表/活动
    findElegantDemeanourByPage: api + 'app/system/findElegantDemeanourByPage', ///分页获取用户服务地址列表/活动
    findEvaluation: api + 'app/user/evaluation/findEvaluation/', ///分页获取用户服务地址列表/活动
    activityDelete: api + 'app/demand/activity/delete/', ///分页获取用户服务地址列表/活动
    elegantDemeanour: api + 'app/system/elegantDemeanour/findOne/', ///分页获取用户服务地址列表/活动
    findServerAbout: api + 'app/system/findServer-about/', ///分页获取用户服务地址列表/活动
    randomCode: api + 'base/verifyCode/randomCode', ///分页获取用户服务地址列表/活动
    findUserPotentialByPage: api + 'app/demand/activity/findUserPotentialByPage', ///分页获取用户服务地址列表/活动
    activityInviteUser: api + 'app/demand/activity/inviteUser', ///分页获取用户服务地址列表/活动
    findPotentialInvite: api + 'app/demand/activity/findPotentialInvite', ///分页获取用户服务地址列表/活动
    activityStart: api + 'app/demand/activity/activity-start/', ///分页获取用户服务地址列表/活动
    prepay: api + 'app/point/recharge/precreate/prepay', ///微信支付宝二维码支付 预支付
    weixinQuery: api + 'app/point/recharge/precreate/weixin/query/', ///微信支付宝二维码支付 预支付
    applyAgree: api + 'app/demand/activity/release/user/apply-agree/', ///微信支付宝二维码支付 预支付
    applyStart: api + 'app/demand/activity/user/apply-start/', ///微信支付宝二维码支付 预支付
    findPaper: api + 'app/paper/findPaper', ///微信支付宝二维码支付 预支付
    paperSave: api + 'app/paper/paper-question/save', ///微信支付宝二维码支付 预支付
    findWelfareByPage: api + 'app/system/findWelfareByPage', ///微信支付宝二维码支付 预支付
    applyComplete: api + 'app/demand/activity/user/apply-complete/' ///微信支付宝二维码支付 预支付
  }
};

/***/ }),

/***/ "25/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4FU0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EAa/":
/***/ (function(module, exports, __webpack_require__) {

//公共模块,接口维护
var urlContant = __webpack_require__("1qkf");

module.exports = {
  URL: urlContant
};

/***/ }),

/***/ "Gsor":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0695475a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("25/P");
function injectStyle (ssrContext) {
  __webpack_require__("Gsor")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0695475a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MvGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "post", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "post1", function() { return post1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "del", function() { return del; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFile", function() { return uploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadVideo", function() { return uploadVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCookie", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateFormate", function() { return dateFormate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCookie", function() { return setCookie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//公共方法
var Vue = __webpack_require__("7+uW");
var sessionId = getCookie('sessionId');
// Vue.http.options.credentials = true;
console.log('公共方法', sessionId);
// console.log('------------');
function post(url, param, callBack) {
  var failBack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var sessionId = getCookie('sessionId');

  Vue.default.http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param), { headers: { 'sessionId': sessionId }, emulateJSON: true, credentials: true }).then(function (res) {
    callBack(res.body);
  }, function (res) {
    if (failBack) {
      failBack(res.body);
    }
  });
}

function dateFormate(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'date';

  var d = new Date(num);
  var year = d.getFullYear();
  var day = d.getDate();
  var month = +d.getMonth() + 1;
  var hour = d.getHours();
  var minute = d.getMinutes();
  var second = d.getSeconds();
  if (type == 'date') {
    var f = year + "-" + formate(month) + "-" + formate(day) + " " + formate(hour) + ":" + formate(minute) + ":" + formate(second);
  } else if (type == 'birth') {
    var f = year + "-" + formate(month) + "-" + formate(day);
  }

  function formate(d) {
    return d > 9 ? d : '0' + d;
  }
  return f;
}

function post1(url, param, callBack) {
  var failBack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  url = url + "?";
  var sessionId = getCookie('sessionId');
  for (var item in param) {
    if (!param[item] && param[item] !== false) {
      delete param[item];
    }
    url += item + '=' + param[item] + '&';
  }
  console.log(url);
  if (url.substr(url.length - 1, 1) == '&') {
    url = url.substr(0, url.length - 1);
  }
  console.log(url);

  Vue.default.http.post(url, '', { headers: { 'sessionId': sessionId }, emulateJSON: true, credentials: true, responseType: 'blob' }).then(function (res) {
    callBack(res.body);
  }, function (res) {
    if (failBack) {
      failBack(res.body);
    }
  });
}

function get(url, param, callBack) {
  var failBack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var sessionId = getCookie('sessionId');
  url = '' + param ? '' + url + param : url;
  Vue.default.http.get(url, { headers: { 'sessionId': sessionId }, emulateJSON: true, credentials: true }).then(function (res) {
    callBack(res.body);
  }, function (res) {
    if (failBack) {
      failBack(res.body);
    }
  });
}
function del(url) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var callBack = arguments[2];
  var failBack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var sessionId = getCookie('sessionId');
  url = '' + param ? '' + url + param : url;
  // for(let item in query){
  //     url = `${url}?${item}=${query[item]}`;
  // }
  Vue.default.http.delete(url, { headers: { 'sessionId': sessionId }, emulateJSON: true, credentials: true }).then(function (res) {
    callBack(res.body);
  }, function (res) {
    if (failBack) {
      failBack(res.body);
    }
  });
}

function uploadFile(url, param, contentType, callBack) {
  var failBack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  // 上传图片到阿里云 / 腾讯云
  Vue.default.http.put(url, param, { headers: { 'Content-Type': contentType }, emulateJSON: false }).then(function (res) {
    callBack(res.data);
  }, function (res) {
    if (failBack) {
      failBack(res.data);
    }
  });
}

function uploadVideo(url, param, contentType) {
  var onprogress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var callBack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var failBack = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  // 上传图片到阿里云
  Vue.default.http.put(url, param, { headers: { 'Content-Type': contentType }, emulateJSON: false,
    progress: function progress(e) {
      onprogress(e);
    }
  }).then(function (res) {
    callBack(res.data);
  }, function (res) {
    if (failBack) {
      failBack(res.data);
    }
  });
}

function setCookie(name, value) {
  var Days = 2;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  // document.cookie = name + "=" + escape(value) ;
  document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
}

//读取cookie：
function getCookie(name) {
  var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}



/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("4kSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_common_css__ = __webpack_require__("4FU0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_common_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var websdk = __webpack_require__("zecL");
var webIM = window.WebIM = websdk;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$WebIM = webIM;
var imConn = new webIM.connection({
  isMultiLoginSessions: webIM.config.isMultiLoginSessions,
  https: typeof webIM.config.https === 'boolean' ? webIM.config.https : location.protocol === 'https:',
  url: webIM.config.xmppURL,
  isAutoLogin: true,
  heartBeatWait: webIM.config.heartBeatWait,
  autoReconnectNumMax: webIM.config.autoReconnectNumMax,
  autoReconnectInterval: webIM.config.autoReconnectInterval,
  apiUrl: webIM.config.apiURL
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$imConn = imConn;

function setCookie(name, value) {
  var Days = 2;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  // document.cookie = name + "=" + escape(value) ;
  document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
}

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
  //拦截器
  request.credentials = false;
  next(function (res) {
    //401 登录过期跳转
    if (res.data.status == 401) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push("/login");
      setCookie('sessionId', '');
      setCookie('objectParam', '');
    }
  });
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



var home = function home(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iMRu")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var register = function register(resolve) {
  return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FSLt")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var login = function login(resolve) {
  return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CE2Z")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var forget = function forget(resolve) {
  return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dbnO")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var serviceCenter = function serviceCenter(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mGrs")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var questionCenter = function questionCenter(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kB2Q")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var activityCenter = function activityCenter(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("We0X")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var activityDetail = function activityDetail(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hioS")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var newsCenter = function newsCenter(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tliW")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var newsDetail = function newsDetail(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yHqO")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var organzation = function organzation(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MZbD")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var groupDetail = function groupDetail(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A0mP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var about = function about(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lm5N")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var aboutDetail = function aboutDetail(resolve) {
  return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4Zbj")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var tipsCenter = function tipsCenter(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KxWf")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var tipsDetail = function tipsDetail(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("l5rQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var serviceDetail = function serviceDetail(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AIgr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myMessage = function myMessage(resolve) {
  return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iIRe")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var fortuneBag = function fortuneBag(resolve) {
  return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xjEA")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var fortuneSend = function fortuneSend(resolve) {
  return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GEB2")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var fortuneIn = function fortuneIn(resolve) {
  return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hbBz")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myMember = function myMember(resolve) {
  return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wRXV")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myOrganzation = function myOrganzation(resolve) {
  return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DmqD")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var changePassword = function changePassword(resolve) {
  return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8akL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myPublish = function myPublish(resolve) {
  return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uuFZ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myReceive = function myReceive(resolve) {
  return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Yb/g")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myActivity = function myActivity(resolve) {
  return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GgbM")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var publishAdd = function publishAdd(resolve) {
  return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/pms")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var serviceAddress = function serviceAddress(resolve) {
  return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1EvM")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var addressAdd = function addressAdd(resolve) {
  return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gf37")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var communityEdit = function communityEdit(resolve) {
  return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qC6b")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var serviceTime = function serviceTime(resolve) {
  return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XIFH")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var serviceAdd = function serviceAdd(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("733r")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var applyPeople = function applyPeople(resolve) {
  return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KHDd")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var memberDetail = function memberDetail(resolve) {
  return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+cfv")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var checkPeople = function checkPeople(resolve) {
  return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("i/IP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var feedBack = function feedBack(resolve) {
  return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gyyc")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var feedBackAdd = function feedBackAdd(resolve) {
  return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M0FP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invitePeople = function invitePeople(resolve) {
  return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/dhd")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var myActivityMember = function myActivityMember(resolve) {
  return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bj7s")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var introduce = function introduce(resolve) {
  return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rF6U")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var organzationDetail = function organzationDetail(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SA9A")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var mySingnalList = function mySingnalList(resolve) {
  return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fnse")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  // base: '/web/',
  routes: [{
    path: '/',
    name: 'home',
    component: home
  }, {
    path: '/register',
    name: 'register',
    component: register
  }, {
    path: '/serviceCenter',
    name: 'serviceCenter',
    component: serviceCenter
  }, {
    path: '/activityCenter',
    name: 'activityCenter',
    component: activityCenter
  }, {
    path: '/about',
    name: 'about',
    component: about
  }, {
    path: '/aboutDetail',
    name: 'aboutDetail',
    component: aboutDetail
  }, {
    path: '/serviceDetail',
    name: 'serviceDetail',
    component: serviceDetail
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/myMessage',
    name: 'myMessage',
    component: myMessage
  }, {
    path: '/fortuneBag',
    name: 'fortuneBag',
    component: fortuneBag
  }, {
    path: '/fortuneSend',
    name: 'fortuneSend',
    component: fortuneSend
  }, {
    path: '/fortuneIn',
    name: 'fortuneIn',
    component: fortuneIn
  }, {
    path: '/myMember',
    name: 'myMember',
    component: myMember
  }, {
    path: '/myOrganzation',
    name: 'myOrganzation',
    component: myOrganzation
  }, {
    path: '/changePassword',
    name: 'changePassword',
    component: changePassword
  }, {
    path: '/myPublish',
    name: 'myPublish',
    component: myPublish
  }, {
    path: '/myReceive',
    name: 'myReceive',
    component: myReceive
  }, {
    path: '/myActivity',
    name: 'myActivity',
    component: myActivity
  }, {
    path: '/forget',
    name: 'forget',
    component: forget
  }, {
    path: '/publishAdd',
    name: 'publishAdd',
    component: publishAdd
  }, {
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter
  }, {
    path: '/newsDetail',
    name: 'newsDetail',
    component: newsDetail
  }, {
    path: '/organzation',
    name: 'organzation',
    component: organzation
  }, {
    path: '/tipsCenter',
    name: 'tipsCenter',
    component: tipsCenter
  }, {
    path: '/tipsDetail',
    name: 'tipsDetail',
    component: tipsDetail
  }, {
    path: '/serviceAddress',
    name: 'serviceAddress',
    component: serviceAddress
  }, {
    path: '/addressAdd',
    name: 'addressAdd',
    component: addressAdd
  }, {
    path: '/communityEdit',
    name: 'communityEdit',
    component: communityEdit
  }, {
    path: '/serviceTime',
    name: 'serviceTime',
    component: serviceTime
  }, {
    path: '/serviceAdd',
    name: 'serviceAdd',
    component: serviceAdd
  }, {
    path: '/applyPeople',
    name: 'applyPeople',
    component: applyPeople
  }, {
    path: '/memberDetail',
    name: 'memberDetail',
    component: memberDetail
  }, {
    path: '/activityDetail',
    name: 'activityDetail',
    component: activityDetail
  }, {
    path: '/checkPeople',
    name: 'checkPeople',
    component: checkPeople
  }, {
    path: '/feedBack',
    name: 'feedBack',
    component: feedBack
  }, {
    path: '/feedBackAdd',
    name: 'feedBackAdd',
    component: feedBackAdd
  }, {
    path: '/groupDetail',
    name: 'groupDetail',
    component: groupDetail
  }, {
    path: '/invitePeople',
    name: 'invitePeople',
    component: invitePeople
  }, {
    path: '/myActivityMember',
    name: 'myActivityMember',
    component: myActivityMember
  }, {
    path: '/introduce',
    name: 'introduce',
    component: introduce
  }, {
    path: '/questionCenter',
    name: 'questionCenter',
    component: questionCenter
  }, {
    path: '/organzationDetail',
    name: 'organzationDetail',
    component: organzationDetail
  }, {
    path: '/mySingnalList',
    name: 'mySingnalList',
    component: mySingnalList
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//

var CONSTANT = __webpack_require__("EAa/"),
    common = __webpack_require__("MvGc");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      info: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var path = this.$router.history.current.fullPath;
    var arr = ['/', '/serviceCenter', '/serviceDetail', '/activityCenter', '/newsCenter', '/newsDetail', '/organzation', '/tipsCenter', '/tipsDetail', '/about', '/aboutDetail', '/login', '/register'];
    if (arr.includes(path)) return;
    this.getInfo();
  },

  methods: {
    getInfo: function getInfo() {
      var _this = this;

      var url = CONSTANT.URL.ADMIN.userCore;
      common.get(url, '', function (res) {
        if (res.status == 200) {
          _this.info = res.data.bussData;
          common.setCookie('objectParam', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.bussData));
        }
      });
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.84eb70caa6a42dce5a23.js